import React from 'react';

import Section from "../../Section";
import Tile from "../../Tile";
import TagGrid from '../../TagGrid';

const arts = [
  "jupiter",
  "pump",
  "sun",
  "yellowp21"
]

export default function Art(props) {
  return <Section>
      <a name="art" />
      <h1 className="h3 mdl-typography--display-1-color-contrast">Art</h1>
      <TagGrid tag={Tile} source={arts} path='/images/art/' />
    </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Art/Art.js